import { render } from "./gameJoiner.vue?vue&type=template&id=3a6814a0&scoped=true"
import script from "./gameJoiner.vue?vue&type=script&lang=js"
export * from "./gameJoiner.vue?vue&type=script&lang=js"

import "./gameJoiner.vue?vue&type=style&index=0&id=3a6814a0&scoped=true&lang=css"

import exportComponent from "/tmp/build_b726cccb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a6814a0"]])

export default __exports__